export const formatPhone = (phone) => {
  if (phone.length === 10 && typeof phone.replace === "function") {
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  }
  return phone;
};
